import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Partner } from '@principle-theorem/principle-core';
import { IPartner } from '@principle-theorem/principle-core/interfaces';
import {
  getDoc$,
  snapshot,
  type ResolverResult,
} from '@principle-theorem/shared';

@Injectable()
export class PartnerResolver {
  resolve(route: ActivatedRouteSnapshot): ResolverResult<IPartner> {
    const uid: string = route.paramMap.get('uid') || '';
    return snapshot(getDoc$(Partner.col(), uid));
  }
}
